"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollingMenu = void 0;
var GiftLayout_1 = require("./GiftLayout");
var GameVars_1 = require("../../../GameVars");
var ShopCell_1 = require("./ShopCell");
var GameConstants_1 = require("../../../GameConstants");
var AchievementsCell_1 = require("./AchievementsCell");
var ScrollingMenu = /** @class */ (function (_super) {
    __extends(ScrollingMenu, _super);
    function ScrollingMenu(scene, name, scrollingLayer) {
        var _this = _super.call(this, scene) || this;
        _this.name = name;
        _this.scrollingLayer = scrollingLayer;
        _this.x = GameVars_1.GameVars.gameWidth / 2;
        _this.y = GameVars_1.GameVars.gameHeight / 2;
        _this.scaleY = GameVars_1.GameVars.scaleY;
        _this.cells = [];
        _this.scrollingDirection = null;
        var frame = new Phaser.GameObjects.Image(_this.scene, 0, 40, "texture_atlas_1", "layout");
        _this.add(frame);
        _this.scrollingContainer = new Phaser.GameObjects.Container(_this.scene);
        _this.add(_this.scrollingContainer);
        var titleBackground = new Phaser.GameObjects.Image(_this.scene, 0, -275, "texture_atlas_0", "title_cookie_base");
        _this.add(titleBackground);
        var title = new Phaser.GameObjects.Image(_this.scene, 0, titleBackground.y, "texture_atlas_1", _this.name === GameConstants_1.GameConstants.SHOP ? "title_shop" : "title_achive");
        _this.add(title);
        if (_this.name === GameConstants_1.GameConstants.SHOP && GameVars_1.GameVars.isVideoRewardAvailable) {
            _this.giftLayout = new GiftLayout_1.GiftLayout(_this.scene);
            _this.add(_this.giftLayout);
        }
        titleBackground.setScale(.75);
        title.setScale(.75);
        var maskShape = new Phaser.GameObjects.Graphics(_this.scene);
        maskShape.fillStyle(0x00FF00);
        maskShape.beginPath();
        maskShape.fillRect(0, 0, GameVars_1.GameVars.gameWidth, _this.name === GameConstants_1.GameConstants.SHOP && GameVars_1.GameVars.isVideoRewardAvailable ? 420 * GameVars_1.GameVars.scaleY : 575 * GameVars_1.GameVars.scaleY);
        maskShape.x = 0;
        maskShape.y = _this.name === GameConstants_1.GameConstants.SHOP && GameVars_1.GameVars.isVideoRewardAvailable ? GameVars_1.GameVars.gameHeight / 2 - 75 * GameVars_1.GameVars.scaleY : GameVars_1.GameVars.gameHeight / 2 - 230 * GameVars_1.GameVars.scaleY;
        _this.scrollingContainer.mask = maskShape.createGeometryMask();
        _this.scrollingContainer.y = -ScrollingMenu.OFFSET;
        var length = _this.name === GameConstants_1.GameConstants.SHOP ? 6 : 7;
        for (var i = 0; i < length; i++) {
            var cell = void 0;
            if (_this.name === GameConstants_1.GameConstants.SHOP) {
                cell = new ShopCell_1.ShopCell(_this.scene, i + 1);
                cell.y = i * ScrollingMenu.DELTA_Y_ITEM;
                _this.scrollingContainer.add(cell);
            }
            else {
                cell = new AchievementsCell_1.AchievementsCell(_this.scene, i + 1);
                cell.y = i * ScrollingMenu.DELTA_Y_ITEM;
                _this.scrollingContainer.add(cell);
            }
            _this.cells.push(cell);
        }
        _this.updateCells();
        _this.scrolling = false;
        _this.scene.input.on("pointerdown", function () {
            _this.scrolling = true;
        }, _this);
        _this.scene.input.on("pointerup", function () {
            _this.scrolling = false;
        }, _this);
        // this.scene.input.on("pointerout", () => {
        //     this.scrolling = false;
        // }, this);
        _this.scene.input.on("pointermove", function (pointer) {
            if (_this.scrolling && _this.scrollingLayer.visible) {
                var prevY = _this.scrollingContainer.y;
                _this.scrollingContainer.y += (pointer.position.y - pointer.prevPosition.y);
                if (prevY > _this.scrollingContainer.y) {
                    _this.scrollingDirection = GameConstants_1.GameConstants.DOWN_DIR;
                }
                else {
                    _this.scrollingDirection = GameConstants_1.GameConstants.UP_DIR;
                }
            }
        }, _this);
        _this.scene.input.on("wheel", function (pointer, dx, dy, dz) {
            if (_this.scrollingLayer.visible) {
                var prevY = _this.scrollingContainer.y;
                _this.scrollingContainer.y -= dz / 4;
                if (prevY > _this.scrollingContainer.y) {
                    _this.scrollingDirection = GameConstants_1.GameConstants.DOWN_DIR;
                }
                else {
                    _this.scrollingDirection = GameConstants_1.GameConstants.UP_DIR;
                }
            }
        }, _this);
        return _this;
    }
    ScrollingMenu.prototype.update = function () {
        if (this.scrollingLayer.visible) {
            var numItems = this.name === GameConstants_1.GameConstants.SHOP ? (GameConstants_1.GameConstants.NUM_ITEMS - 3 - GameVars_1.GameVars.modeGameData.restartCounter - 1) : 7 + 1;
            if (this.scrollingDirection === GameConstants_1.GameConstants.DOWN_DIR) {
                var firstCell = this.cells[0];
                var firstCellY = firstCell.y + this.scrollingContainer.y + ScrollingMenu.OFFSET;
                if (firstCellY < -ScrollingMenu.DELTA_Y_ITEM) {
                    // sacarla del array
                    this.cells.shift();
                    var lastCell = this.cells[this.cells.length - 1];
                    firstCell.y = lastCell.y + ScrollingMenu.DELTA_Y_ITEM;
                    var i = lastCell.i + 1 <= numItems - 1 ? lastCell.i + 1 : 0;
                    firstCell.reset(i);
                    // meterla de nuevo
                    this.cells.push(firstCell);
                }
            }
            else {
                var lastCell = this.cells[this.cells.length - 1];
                var lastCellY = lastCell.y + this.scrollingContainer.y + ScrollingMenu.OFFSET;
                if (lastCellY > 5 * ScrollingMenu.DELTA_Y_ITEM) {
                    // sacarla del array
                    this.cells.pop();
                    var firstCell = this.cells[0];
                    lastCell.y = firstCell.y - ScrollingMenu.DELTA_Y_ITEM;
                    var i = firstCell.i - 1 >= 0 ? firstCell.i - 1 : numItems - 1;
                    lastCell.reset(i);
                    this.cells.unshift(lastCell);
                }
            }
        }
        for (var i = 0; i < this.cells.length; i++) {
            this.cells[i].update();
        }
        if (this.name === GameConstants_1.GameConstants.SHOP && GameVars_1.GameVars.isVideoRewardAvailable) {
            this.giftLayout.update();
        }
    };
    ScrollingMenu.prototype.updateCells = function () {
        if (this.name === GameConstants_1.GameConstants.SHOP) {
            this.scrollingContainer.y = -ScrollingMenu.OFFSET;
            var extra = 0;
            if (!GameVars_1.GameVars.isVideoRewardAvailable) {
                if (GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 4 === GameVars_1.GameVars.modeGameData.restartCounter + 1) {
                    extra = 2;
                }
                else if (GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 4 === GameVars_1.GameVars.modeGameData.restartCounter + 2) {
                    extra = 1;
                }
            }
            else {
                if (GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 4 === GameVars_1.GameVars.modeGameData.restartCounter + 1) {
                    extra = 1;
                }
            }
            for (var i = 0; i < this.cells.length; i++) {
                var index = i + GameVars_1.GameVars.modeGameData.iMaxItemUncovered - 7 - GameVars_1.GameVars.modeGameData.restartCounter + extra;
                if (index < 0) {
                    index = 38 + index - GameVars_1.GameVars.modeGameData.restartCounter;
                }
                this.cells[i].reset(index);
            }
        }
        else {
            for (var i = 0; i < this.cells.length; i++) {
                this.cells[i].reset(i);
            }
        }
    };
    ScrollingMenu.prototype.hideNews = function () {
        for (var i = 0; i < this.cells.length; i++) {
            this.cells[i].hideNews();
        }
    };
    ScrollingMenu.DELTA_Y_ITEM = 130;
    ScrollingMenu.OFFSET = 145;
    return ScrollingMenu;
}(Phaser.GameObjects.Container));
exports.ScrollingMenu = ScrollingMenu;
